// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"2e0b02a8","131":"7faf568c","232":"98eb8a48","262":"8e0fabb0","299":"120cb236","424":"65c21eca"}[chunkId] + ".chunk.js";
};